export default __webpack_public_path__ + "static/tablet_sek2_KV04-5746a8a27d396a62fa245bb54c77759c.mp4";